module.exports = __webpack_public_path__ + "img/logo-cassems.a377082d.png";